import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Plus, Search, AlertTriangle } from 'lucide-react';
import api from '../utils/api';
import { toast } from 'sonner';

export const CustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadCustomers();
  }, [search]); // eslint-disable-line

  const loadCustomers = async () => {
    try {
      const response = await api.getCustomers(search);
      setCustomers(response.data);
    } catch (error) {
      toast.error('Errore nel caricamento clienti');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="customers-page">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 mb-1">Clienti</h1>
          <p className="text-slate-600 text-sm">Gestisci i tuoi clienti e progetti</p>
        </div>
        <Button onClick={() => navigate('/app/customers/new')} data-testid="create-customer-btn">
          <Plus size={18} className="mr-2" />
          Nuovo Cliente
        </Button>
      </div>

      {/* Search */}
      <Card className="mb-6">
        <CardContent className="p-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} />
            <Input
              placeholder="Cerca cliente per nome o ditta..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-10"
              data-testid="customer-search-input"
            />
          </div>
        </CardContent>
      </Card>

      {/* Customers List */}
      <Card>
        <CardHeader>
          <CardTitle>Tutti i Clienti</CardTitle>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="space-y-3">
              {[1, 2, 3].map(i => (
                <div key={i} className="h-16 bg-slate-100 animate-pulse rounded"></div>
              ))}
            </div>
          ) : customers.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-slate-600">Nessun cliente trovato</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-secondary border-b">
                  <tr>
                    <th className="text-left p-4 text-sm font-semibold text-slate-700">Nome/Ditta</th>
                    <th className="text-left p-4 text-sm font-semibold text-slate-700">Email</th>
                    <th className="text-left p-4 text-sm font-semibold text-slate-700">Telefono</th>
                    <th className="text-left p-4 text-sm font-semibold text-slate-700">Citta</th>
                  </tr>
                </thead>
                <tbody>
                  {customers.map(customer => (
                    <tr
                      key={customer.id}
                      className="border-b hover:bg-secondary cursor-pointer transition-colors"
                      onClick={() => navigate(`/app/customers/${customer.id}`)}
                      data-testid={`customer-row-${customer.id}`}
                    >
                      <td className="p-4">
                        <div className="flex items-center gap-2">
                          {customer.has_problem && (
                            <AlertTriangle className="h-4 w-4 text-red-500 flex-shrink-0" />
                          )}
                          <span className="font-medium text-slate-900">{customer.name_or_company}</span>
                        </div>
                      </td>
                      <td className="p-4 text-slate-600">{customer.billing_email}</td>
                      <td className="p-4 text-slate-600">{customer.phone_mobile || customer.phone_office}</td>
                      <td className="p-4 text-slate-600">{customer.address_city || customer.billing_address_city}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
